import { makeStyles } from "@material-ui/styles";
import styled from "styled-components";

export const ModalControl = styled.a`
    display: none;
    vertical-align: top;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    cursor: pointer;
`;

export const Back = styled.div`
    display: inline-flex;
    cursor: pointer;
    margin: 1rem 0.5rem;
`;

export const Content = styled.div`
    width: 310px;
`;

export const FormField = styled.div`
    margin: 2rem 0 1rem 0;
`;

export const Action = styled.div`
    margin: 3.5rem 0;
    text-align: right;
    > button.MuiButton-root {
        margin-left: 2rem;
        margin-right: 0;
        min-width: 8.75rem;
        height: 2.625rem;
    }
    > button.MuiButton-root:hover {
        opacity: 0.75;
        box-shadow: none;
        background-color: ${globalThis.config.colors.black};
    }
`;

export const ContentWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 6.125rem;
`;

export const useStyles = makeStyles(() => ({
    root: {
        "& .modal-content": {
            height: globalThis.config.sizes.modal.height,
        },
    },
}));
